import { render, staticRenderFns } from "./ValidateSecurityCode.vue?vue&type=template&id=55d6a4e8&"
import script from "./ValidateSecurityCode.vue?vue&type=script&lang=js&"
export * from "./ValidateSecurityCode.vue?vue&type=script&lang=js&"
import style0 from "./ValidateSecurityCode.vue?vue&type=style&index=0&id=55d6a4e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports